(function()
{
	//Import classes
	var BaseState = include('WGBH.BaseState'),
		GamePanel = include('WGBH.GamePanel'),

	
	Point=include("PIXI.Point"),
	Sprite=include("PIXI.Sprite"),
	Button=include("springroll.pixi.Button"),
	Text=include("PIXI.Text"),
	Container=include("PIXI.Container"),
	
	Tween=include("createjs.Tween"),
	Ease=include("createjs.Ease"),
	
	RuffPointer=include("WGBH.pixi.RuffPointer"),
	
	
	EventDispatcher=include('springroll.EventDispatcher'),

	
	Phys=include('WGBH.PhysicsManagerBox2d'),
	Renderer=include('WGBH.PhysicsRenderer'),
	WorldObject=include('WGBH.WorldObject');


	/**
	 * The logic for the title state
	 * @class WGBH.GameState
	 * @extends springroll.easeljs.BaseState
	 */
	var GameState = function(options)
	{
		BaseState.call(this, new GamePanel(), options);

	};
	
	// http://www.iforce2d.net/b2dtut/raycasting
	
	
var launcher,next,prev,retry,
thumb,extending,level;

var adminmode;
var roundinterlude; //when to interrupt the endless series of rounds for a litle break

var forcelevel=0;
var framemargin=[300,100],slidemode='v';
var shotlimit;
var whichtool;
var maxlevel=0;
var t1=0;
var t2=30;
var t3=0;
var mode="play";
var pullmode=true;

var gamemode;

var synth=new WGBH.SoundSynth();


var DEG_TO_RAD = Math.PI / 180;
var getqs=function(key) {
		var qst=window.location.search.substring(1).split('&');
		var re=new RegExp(key);
		for(var z in qst) {
			if(re.test(qst[z])) {	
				var sp=qst[z].split('=');
				return sp[1];
			}
		}
		
		return false;
	};
	


	// Extend the base class
	var p = extend(GameState, BaseState);

	/**
	 * When the transition is done playing and we're fully in
	 */
	p.enterDone = function()
	{
		synth.makenoise();
		this.icerink.events.on('stasis',this.stopped);
		
		this.icerink.events.on('setforce',this.movethumbto);
		this.icerink.events.on('shot',this.shot);
		this.icerink.events.on('feedback',this.givefeedback);
		this.icerink.tooltype='fish'; // always a fish
		
		this.getuserlevels();
		this.showindex();
	};
	
	p.buttonclick=function() {	
		app.soundtrack.playSFX('clickey');
	};
		
	p.startsynth=function() {
		synth.makenoise();
			// create empty buffer
		var buffer = synth.audioCtx.createBuffer(1, 1, 22050);
		var source = synth.audioCtx.createBufferSource();
		source.buffer = buffer;

	// connect to output (your speakers)
		source.connect(synth.audioCtx.destination);

	// play the file
		source.noteOn(0);
		document.removeEventListener('touchend',this.startsynth);
	};
	
	p.setupgame=function() {
		adminmode=app.config.gameoptions.showadmin;
		if(getqs('admin')) {
			adminmode=getqs('admin')==1;
		}
		roundinterlude=app.config.gameoptions.levelbreak; //when to interrupt the endless series of rounds for a litle break

		document.addEventListener('touchend',this.startsynth); // put this on a touch handler for mobile
		
		this.clickedruff=this.clickedruff.bind(this);
		
		
		this.rufflines=app.config.ruffmovements;

		
		this.stopped=this.stopped.bind(this);
		this.movethumbto=this.movethumbto.bind(this);
		this.shot=this.shot.bind(this);
		
		this.givefeedback=this.givefeedback.bind(this);

		this.nextruff=this.nextruff.bind(this);

		this.shootit=this.shootit.bind(this);

		
		this.chooseskip=this.chooseskip.bind(this);
		this.choosenext=this.choosenext.bind(this);
		this.chooseretry=this.chooseretry.bind(this);
		this.chooseprev=this.chooseprev.bind(this);

		this.updateeditui=this.updateeditui.bind(this);
		
		this.clickice=this.clickice.bind(this);
		this.clickbg=this.clickbg.bind(this);
			
		this.clickhome=this.clickhome.bind(this);
		
		this.draglauncher=this.draglauncher.bind(this);
		
		this.dragthumb=this.dragthumb.bind(this);
		this.dropthumb=this.dropthumb.bind(this);
		this.movethumb=this.movethumb.bind(this);
		
		this.addthing=this.addthing.bind(this);

		this.toggleguide=this.toggleguide.bind(this);
				
		this.toplaymode=this.toplaymode.bind(this);
		this.backtoeditmode=this.backtoeditmode.bind(this);
		
		this.chooseplay=this.chooseplay.bind(this);			
		this.choosecreate=this.choosecreate.bind(this);
		this.clearcreate=this.clearcreate.bind(this);
		
		this.choosecreatedlevel=this.choosecreatedlevel.bind(this);
		this.createnewlevel=this.createnewlevel.bind(this);
		
		this.togglelevelconfig=this.togglelevelconfig.bind(this);
		this.switchcreatetype=this.switchcreatetype.bind(this);
		
		this.movelauncher=this.movelauncher.bind(this);
		this.matchlauncher=this.matchlauncher.bind(this);
		this.showstar=this.showstar.bind(this);
		this.showtarget=this.showtarget.bind(this);
		this.switchmouth=this.switchmouth.bind(this);
		this.moveslider=this.moveslider.bind(this);
		this.readthumb=this.readthumb.bind(this);
		this.adjusttouched=this.adjusttouched.bind(this);
		
		this.togglepositionlock=this.togglepositionlock.bind(this);
		this.toggleforcelock=this.toggleforcelock.bind(this);
		
		this.showanswer=this.showanswer.bind(this);
		
		this.endinterlude=this.endinterlude.bind(this);
		this.backhome=this.backhome.bind(this);
		
	//	this.panel.hideitem("gamecontainer");
		
		this.icerink=new WGBH.IceRink();
		this.ruffcorner=new RuffPointer({'itempath':this});
		this.saying={audio:null,type:null};

		this.roundid="";
		app.roundid=this.roundid;
		this.currentround=null; // object
		this.roundhistory=[];
		this.roundnumber=0;

		this.userstatus={
			heardintro:{}
		}; // keep track of things the user has seen and heard so as not to present them unnecessarily
		
		
		
		this.enableon={}; // sometimes shooting is only available if user has moved some things
		
		this.gamestuff=["icerink","icebg","iceshine","retrypanel","launcher","controls","levelnav","hint","editpanel"];
		
		for(var ui in app.config.layouts.gameui) {
			var it=this.panel.additem(app.config.layouts.gameui[ui]);
		}
		
		
		var actions={
		
			"b_playbutton":[this.chooseplay],
			"b_createbutton":[this.choosecreate],
			
			"b_buttonshowme":[this.showanswer],
			"b_choosecreatedlevel":[this.choosecreatedlevel],	
			"b_createnewlevel":[this.createnewlevel],			
		
			"b_buttonnext":[this.chooseskip],
			"b_buttonprev":[this.chooseprev],
			"b_buttonretry":[this.chooseretry],
			
			"b_retrybutton":[this.chooseretry],
			"b_nextlevelbutton":[this.choosenext],
			"b_launcher":[this.draglauncher],
			
			"b_buttonguide":[this.toggleguide],
			"b_clearcreate":[this.clearcreate],
			"b_switchtoplay":[this.toplaymode],
			"b_switchtoedit":[this.backtoeditmode],
			"b_thumb":[this.dragthumb],
			"b_launchbutton":[this.shootit],
			"b_icebg":[this.clickice],
			
			"b_addbonus":[this.addthing],
			"b_addpenguin":[this.addthing],
			"b_addhole":[this.addthing],
			"b_addsand":[this.addthing],
			"b_addmovingpenguin":[this.addthing],
			"b_addtargetplace":[this.addthing],
			"b_addstarguess":[this.addthing],
			"b_addbush":[this.addthing],
			
			"b_homebutton":[this.clickhome],
			"b_showconfig":[this.togglelevelconfig],
			"b_switchcreatetype":[this.switchcreatetype],
			"b_lockforce":[this.toggleforcelock],
			"b_lockposition":[this.togglepositionlock],
			"b_showeditguide":[this.toggleguide]
			
		};
		
		for(var act in actions) {
			this.panel.buttons.off(act,actions[act][0]); // bind here?
			this.panel.buttons.on(act,actions[act][0]);
			if(actions[act][1]) {
				this.panel.buttons.off(act + "_o",actions[act][1]);
				this.panel.buttons.on(act + "_o",actions[act][1]);
			}
		}

		this.panel.buttons.on("background",this.clickbg);
		
		var me=this;
		
		this.zamboni=this.panel.items.zamboni;
		this.zamboni.scaledhalfwidth=this.zamboni.initconfig.frame.w/2;
		this.zamboni.scaledhalfheight=this.zamboni.initconfig.frame.h/2;
		this.zamboni.position.x=0-this.zamboni.scaledhalfwidth;
		
		
		thumb=this.panel.items.thumb;
		thumb.range=thumb.max-thumb.min;
		

		launcher=this.panel.items.launcher;
		launchcircle=this.panel.items.launchcircle;
		launchcircle.gradient.range=[launchcircle.gradient.end[0]-launchcircle.gradient.start[0], launchcircle.gradient.end[1]-launchcircle.gradient.start[1], launchcircle.gradient.end[2]-launchcircle.gradient.start[2]];
	
		
		launchcircle.setcolor=function(rgb){
			this.hexcolor=WGBH.UIPanel.rgb2hex(rgb[0],rgb[1],rgb[2]);
			var newfill=this.hexcolor;//rgb[0]*65536 + rgb[1]*256 + rgb[2];
			this.cacheAsBitmap=false;
			this.clear();
			WGBH.UIPanel.makeGraphicsFromShapes({'forms':this.initconfig.forms, 'image':null,'fill':{'color':newfill},'line':this.initconfig.line},this);
		};
		

		shotlimit=app.config.gameoptions.shotlimit;
		this.rink=new Container();
		
		this.panel.icerink=this.rink;
		
		this.panel.addChild(this.rink);
		
		this.background=this.panel.background;

		this.feedback={};
		this.panel.setChildIndex(this.panel.items.playitems,this.panel.children.length-1);
		this.panel.setChildIndex(this.panel.items.scrim,this.panel.children.length-1);
		this.panel.setChildIndex(this.panel.items.retryscale,this.panel.children.length-1);
		
		// need to calculate retry panel's in/out position after all scaling has happened.
		
		this.panel.items.retrypanel.xin=this.panel.items.retrypanel.position.x;
		this.panel.items.retrypanel.xout=this.panel.items.retrypanel.xin + 130;
		
		this.icerink.setup(this.panel,this.rink,this);

		
		this.panel.addChild(this.ruffcorner);
		this.panel.ruffcorner=this.ruffcorner;
		this.ruffcorner.on(app.taptype,function(ev) {me.clickedruff(ev);});
		
		this.thumb=thumb;
	
	
		// for intro stuff:
		
		this.ruffcorner.events.on("movelauncher",this.movelauncher);
		this.ruffcorner.events.on("moveslider",this.moveslider);
		this.ruffcorner.events.on("showstar",this.showstar);
		this.ruffcorner.events.on("showtarget",this.showtarget);
		
		this.ruffcorner.events.on("pointedat",this.adjusttouched);
		this.ruffcorner.events.on("changemouth",this.switchmouth);
		
		if(adminmode) {
			//this.panel.items.admin.visible=true;
			this.panel.showitem('admin');
			this.panel.showitem('levelnav');
			for(var item in this.panel.admin.initconfig.resets) {
				var conf=this.panel.admin.initconfig.resets[item];
				if(this.panel[item]) {
					if(conf.hidden) {
						this.panel[item].visible=false;
					} else if(conf.frame) {
						this.panel[item].position.x=conf.frame.x;
					}
				}
			}
		} else {
			this.panel.hideitem('admin');
			this.panel.hideitem('levelnav');
		}
	
	};

	p.adjusttouched=function(item) {
		if(item.id) {
		// pointing to an object...
		// need to bring each of playbutton and createbutton to the top when touched so that they overlap properly
			if(item.id==='playbutton' || item.id==='createbutton') {
				this.panel.bringtotop(item,item.parent);
			}
		}
	};
	
	p.movelauncher=function() { // In the intro, where Ruff Pointer moves the launcher
		var launch=this.icerink.getlauncher();
		this.showlauncherpos={x:launch.position.x,y:launch.position.y};
		
		newy=this.showlauncherpos.y-100;
		oldy=this.showlauncherpos.y;
		var duration=750;
		var ease=Ease.quadInOut;
		
		this.ruffcorner.follow(launch,"E");
		Tween.get(this.showlauncherpos).to({y:newy},duration,ease).to({y:oldy},duration,ease);
		
		app.off('update',this.matchlauncher);
		
		var me=this;
		app.setTimeout(function() {app.off('update',me.matchlauncher);},duration*2);
		app.on('update',this.matchlauncher);
	};
	
	p.matchlauncher=function() {
		this.icerink.putlauncher(this.showlauncherpos.x,this.showlauncherpos.y);
	};
	
	p.moveslider=function() { // In the intro where Ruff Pointer moves the slider
		var oldx=this.thumb.position.x;
		var newx=this.thumb.position.x+200;
		if(newx > this.thumb.max) {
			// too far? go the other way instead
			newx=this.thumb.position.x-200;
		}
		var duration=750;
		var ease=Ease.quadInOut;
		this.ruffcorner.follow(this.thumb,"NE");
		Tween.get(this.thumb.position).to({x:newx},duration,ease).to({x:oldx},duration,ease);
		Tween.get(this.panel.items.thumbtext.position).to({x:newx},duration,ease).to({x:oldx},duration,ease);
		this.showthumb=true;
		app.off('update',this.readthumb);
		app.on('update',this.readthumb);
		var me=this;
		app.setTimeout(function() {me.showthumb=false;app.off('update',me.readthumb);},duration*2);
	};
	
	p.switchmouth=function(ev) {
		this.ruffcorner.switchmouth(ev);
	};
	
	p.showstar=function(ev) {
		// don't turn them on/off if USER has already clicked any of them 
		if(this.stars[0].userchanged || this.stars[1].userchanged) return;
		
		switch(parseInt(ev)) {
			case 1:// turn on one star
				this.icerink.selectstar(this.stars[0],true);
				this.stars[0].userchanged=false;
			break;
			
			case 2://turn off the first star
				this.icerink.selectstar(this.stars[0],false);
				this.stars[0].userchanged=false;
			break;
			
			case 3:// turn on the second star
				this.icerink.selectstar(this.stars[1],true);
				this.stars[1].userchanged=false;
			break;
			
			case 4:// turn off the second star
				this.icerink.selectstar(this.stars[1],false);
				this.stars[1].userchanged=false;
			break;
		
		}
	};
	
	p.showtarget=function() {
	
	};
	
	p.clickhome=function() {
		// quiet the sounds too
		app.soundtrack.bequiet();
		this.showretry("hide");
		this.lastruffmessage=[];
		this.guideoff();
		//if exiting create mode, save where we are
		if(gamemode=="create" && this.currentround!==null) {
			// and save the user's creation, unless it hasn't been edited...
			if(this.currentlevelchanged) {
				this.icerink.savecreatedlevel();
			}
			this.trackendcreate();
		}

		// also remove any extra stuff from edit mode
		if(this.icerink.editmode) this.icerink.stopedit();
		this.icerink.teardown();
		this.showindex();
		
		// may need to track end of a creation or end of a round if one has begun
		this.trackclickhome(gamemode);
		
		app.soundtrack.playSFX('hop5');
	};
	
	p.showindex=function(afterwin) {
		this.roundid=app.roundid="";		
		this.createisunlocked=app.usersavestate.cancreate;
		this.panel.indexpane(this.createisunlocked);
		this.hideconfig();
		this.panel.hideitem("createindex");
		this.hidegamestuff();
		this.panel.hideitem('homebutton');
		this.background=this.panel.background1;
		if(afterwin) {
			var line=this.rufflines.intros.afterwin.concat(this.rufflines.intros.gameindex);
			this.ruffsayline(line,'intro');
		} else if(this.createisunlocked) {
			// only 
			this.ruffsayline(this.rufflines.intros.gameindex,'intro');
		} else {
			this.ruffsayline(this.rufflines.intros.indexplay,'intro');
		}
	};
	
	p.hidegamestuff=function() {
	
		app.off('update',this.readthumb);
		app.off('update',this.matchlauncher);
		this.showgamestuff(false);
	};
	
	p.showgamestuff=function(noshow) {
	
		this.panel.showitem('homebutton');
		var show=(noshow!==false);
		for(var thing in this.gamestuff) {
			if(this[this.gamestuff[thing]]) {
				this[this.gamestuff[thing]].visible=show;
				this.panel.hideitem(this.gamestuff[thing]);
			}else if (this.panel[this.gamestuff[thing]]) {
				this.panel.showitem(this.gamestuff[thing]);			
				this.panel[this.gamestuff[thing]].visible=show;
			}
		}
		if(show) {
			this.panel.showgamestuff();
			this.icerink.show();
		} else {
			this.dismissruff();
			this.icerink.hide();
		}
		
		if(!adminmode) {
			this.panel.hideitem("levelnav");
		}
	};
	
	p.chooseplay=function() {
		gamemode="play";
		this.buttonclick();
		this.dismissruff();
		this.ruffcorner.backtocorner(0);
		this.trackstartplaymode();
		this.iscreating=false;
		this.icerink.editmode=false;

		this.panel.hideindex();
		
		this.showgamestuff();
		this.panel.hideitem("switchtoedit");
		
		currentlevel=-1;
		
		this.roundhistory=[];
		
		if(getqs('lv') || getqs('kid')) {
			this.urllevel();
		} else {
			this.newround();
		}
	};
	
		
	p.choosecreate=function() {
		if(!this.createisunlocked) return;
		gamemode="create";
		
		this.buttonclick();
		this.dismissruff();
		this.currentround=null;
		this.roundid=app.roundid="";
		this.trackstartcreatemode();
		this.panel.hideindex();		
		this.panel.showitem('homebutton');
		this.iscreating=true;
		this.panel.hideitem("levelnav");
		this.showcreateindex();
	};
	
	p.clearcreate=function() {
		this.buttonclick();
		this.setcreate(false,true);		
		this.icerink.startedit();
	};
	
	p.thumbnailbuttonfromconfig=function(config) {
				
			var thumbnail=this.panel.additem(app.config.layouts.elements.choosecreatedlevel,"none");
			
			var ws=this.icerink.worldsetupfromlevel(config,retry);
			
			var userrink=this.icerink.thumbnailfromstate(ws);
			userrink.scale={x:0.3,y:0.3};
			userrink.position=new Point(28,102);
			
			thumbnail.addChild(userrink);
			
			return thumbnail;
	};
	
	p.showcreateindex=function(){
		this.panel.hideitem("levelnav");
		this.panel.showitem("createindex");
		var maxuserlevels=3;
		app.off('update',this.readthumb);
		app.off('update',this.matchlauncher);
		var lastuserlevel=this.usercreatedlevels.length;
		var w=340;
		var y=210;
		var ws,thumbnail;
		if(getqs('lv') || getqs('kid')) {
			if(this.panel.items.thumbnailurl) {
				this.panel.createindex.removeChild(this.panel.items.thumbnailurl);
			}
			if(getqs('kid')) {
				thumbnail=this.thumbnailbuttonfromconfig(this.lookupkidlevel(getqs('kid')));
			} else {
				thumbnail=this.thumbnailbuttonfromconfig(this.parselevelurl());
			}
			thumbnail.levelnumber=0;
			thumbnail.position=new Point(w*-1,y);
			this.panel.createindex.addChild(thumbnail);
			thumbnail.cacheAsBitmap=true;
			this.panel.items.thumbnailurl=thumbnail;
		}
		
		for(var i=0;i<lastuserlevel;i++) {
			if(!this.usercreatedlevels[i]) continue;
			
			if(this.panel.items["thumbnail"+i]) {
				this.panel.createindex.removeChild(this.panel.items["thumbnail"+i]);
			}
			
			thumbnail=this.thumbnailbuttonfromconfig(this.usercreatedlevels[i]);
			thumbnail.levelnumber=(1+i);
			thumbnail.position=new Point(i*w,y);
			this.panel.createindex.addChild(thumbnail);
			this.panel.items["thumbnail"+i]=thumbnail;
		}
		
		if(i<maxuserlevels) {
			var nl=this.panel.additem(app.config.layouts.elements.createnewlevel,this.panel.createindex);
			nl.position=new Point(i * w,y);
			nl.levelnumber=(1+i);
		}
	//	this.ruffcorner.saythings(this.rufflines.intros.createintro.none[0].audio);
		var whatcreate=this.rufflines.intros.createintro.none;
		if(lastuserlevel===maxuserlevels) {
			whatcreate=this.rufflines.intros.createintro.all;
		} else if(lastuserlevel > 0) {
			whatcreate=this.rufflines.intros.createintro.some;
		}
		this.ruffsayline(whatcreate,"intro");
	};
	
	p.ruffsayline=function(lineconfig,type,justbeready,repeatmessage) {
			this.ruffstuff=[];
			this.ruffstuff=this.ruffstuff.concat(lineconfig);
			// if it's an alert, don't save for repeat
			if(type != "alert") {
				this.lastruffmessage = [];
				if(repeatmessage) {
					this.lastruffmessage = this.lastruffmessage.concat(repeatmessage);
				} else {
					this.lastruffmessage = this.lastruffmessage.concat(this.ruffstuff);
				}
			}
			if(!justbeready) {
				this.ruffcorner.backtocorner();
				this.nextruff();
			} else { // don't actually say the line, just set up the line in case user clicks on ruff
				this.ruffstuff=[];
			}
			if(type == "intro") {
				this.lastintro=lineconfig.slice();	
			}
	
	// "instruction" "feedbackcorrect" or "feedbackincorrect" to track. Now tracks type PER AUDIO FILE instead of here, where the lines could be put together for fewer calls.
	
	};
	
	p.createnewlevel=function(ev) {
		this.panel.hideitem("createindex");	
		this.createdpick=ev.target.levelnumber-1;
		this.showcreatemode();
		this.trackstartcreate(true);
		if(!this.userstatus.heardintro.createintro) {
			this.ruffsayline(this.rufflines.intros.chosecreated);
			this.userstatus.heardintro.createintro=true;
		} else {
		
			this.ruffsayline(this.rufflines.intros.chosecreatedshort);
		}
	};
	
	p.choosecreatedlevel=function(ev) {	
	
		this.buttonclick();
		this.createdpick=0;
		var lev=ev.target.levelnumber;
		
		this.createdpick=lev-1;
		
		this.panel.hideitem("createindex");		
		this.showcreatemode();
		this.trackstartcreate(false);
		this.ruffsayline(this.rufflines.intros.choseedited);
	};
	
	p.showcreatemode=function() {
		this.showgamestuff();
		this.setcreate();
		this.backtoeditmode();
	};
	

	p.givefeedback=function(ev) {
		this.ruffstuff=[];
		this.lastruffmessage=[];
		var pickwhich,nextstatus,lastgeneric,pickgeneric;
		if(ev.type==="fail") {
			if(ev.goal.type!=="predict") {
				if(this.icerink.distancefromtarget < app.config.gameoptions.closetotarget) {	
					var genericclose=parseInt(Math.random() * this.rufflines.feedback.generic.fail_close.length);
					genericclose=this.rufflines.feedback.generic.fail_close[genericclose];
					this.ruffstuff=this.ruffstuff.concat(this.rufflines.feedback[genericclose]);
				}
			}
		
			var generictryagain=parseInt(Math.random() * this.rufflines.feedback.generic.fail_tryagain.length);
			generictryagain=this.rufflines.feedback.generic.fail_tryagain[generictryagain];
		
			if(this.rufflines.feedback[ev.status]) {	// there is specific feedback for this failure mode	
				if(this.rufflines.feedback[ev.status].d) {  // some kinds cycle through (d)escriptive, (i)nquisitive, (p)rescriptive	
					nextstatus="d";
					if(this.feedback[ev.status]) {
						switch(this.feedback[ev.status]) {
							case "d":
							nextstatus="i";
							break;
							case "i":
							nextstatus="p";
							break;
							case "p":
							nextstatus="d";
							break;
						}
					}

					if(this.rufflines.feedback[ev.status][nextstatus]) {
						this.feedback[ev.status]=nextstatus;
						this.ruffstuff=this.ruffstuff.concat(this.rufflines.feedback[ev.status][nextstatus]);
					}
				} else {
					this.ruffstuff=this.ruffstuff.concat(this.rufflines.feedback[ev.status]);
				}
			} else if(this.rufflines.feedback.generic[ev.status]) {
				// pick from the generic ones
				if(!this.feedback.generic) {
					this.feedback.generic={};
				}
				
				lastgeneric=this.feedback.generic[ev.status]?this.feedback.generic[ev.status]:0;
				nextstatus=(lastgeneric+1)%this.rufflines.feedback.generic[ev.status].length;
				pickwhich=this.rufflines.feedback.generic[ev.status][nextstatus];
				
				this.feedback.generic[ev.status]=nextstatus;
				this.ruffstuff=this.ruffstuff.concat(this.rufflines.feedback[pickwhich]);
				
			}
			
			// point to the retry button if you haven't yet
			if(!this.userstatus.heardretry && !this.iscreating) {
				this.ruffstuff=this.ruffstuff.concat(this.rufflines.intros.showretry);
				this.userstatus.heardretry=true;
			}

			
			// failure in create mode COULD be an unwinnable level - what then?
			// if forcetoohigh or forcetoolow, game has determined it's a winnable shot. Otherwise, it's unknown.
			var winnable=(ev.status==="forcetoohigh" || ev.status==="forcelowpenguin");
			if(this.iscreating) {
				var threshold=winnable?0.8:0.5; // if it's winnable, be less likely to suggest changing the level
				if(Math.random() > threshold) {
				// make a suggestion about changing the level...
					var gencreate=parseInt(Math.random() * this.rufflines.feedback.generic.fail_creation.length);
					generictryagain=this.rufflines.feedback.generic.fail_creation[gencreate];
					this.ruffstuff=this.ruffstuff.concat(this.rufflines.feedback[generictryagain]);
				}
			}
		} else { 
		// SUCCESS!
			if(ev.goal.type==="predict") {
				if(ev.goal.config==="stars") {
					this.ruffstuff=this.ruffstuff.concat(this.rufflines.feedback.success_sfx_predictstars);
					this.ruffstuff=this.ruffstuff.concat(this.rufflines.feedback.success_stars);
				} else {
					if(!this.feedback.generic) {
						this.feedback.generic={};
					}
					this.ruffstuff=this.ruffstuff.concat(this.rufflines.feedback.success_sfx_predicttarget);
					lastgeneric=this.feedback.generic.success_predict?this.feedback.generic.success_predict:0;
					nextstatus=(lastgeneric+1)%this.rufflines.feedback.generic.success_predict.length;
				
					pickwhich=this.rufflines.feedback.generic.success_predict[nextstatus];
		
					this.feedback.generic.success_predict=nextstatus;
					this.ruffstuff=this.ruffstuff.concat(this.rufflines.feedback[pickwhich]);
				}
			} else {
				this.ruffstuff=this.ruffstuff.concat(this.rufflines.feedback.success_sfx);
				this.ruffstuff=this.ruffstuff.concat(this.rufflines.feedback["success_" + ev.status]);	
			}
			
			pickgeneric=parseInt(Math.random() * this.rufflines.feedback.generic.success_next.length);
			pickwhich=this.rufflines.feedback.generic.success_next[pickgeneric];	
			this.ruffstuff=this.ruffstuff.concat(this.rufflines.feedback[pickwhich]);

			// point to the retry button if you haven't yet
			if(!this.userstatus.heardnext && !this.iscreating) {
				this.ruffstuff=this.ruffstuff.concat(this.rufflines.intros.shownext);
				this.userstatus.heardnext=true;
			} else if(this.iscreating) {	
				if(Math.random() < 0.3) { // wish we had some more lines about going back to edit mode...
					this.ruffstuff = this.ruffstuff.concat(this.rufflines.feedback.createsuccess1);
				}
			}
		}
		
		this.lastruffmessage=this.lastruffmessage.concat(this.ruffstuff);
		this.nextruff();
	};
	
	p.draglauncher=function(ev) {
		if(this.playmode!='play') return;
		if(this.icerink.getlockedposition()) {
			this.positionalert();
		}
		var coords={'x':ev.x,'y':ev.y};
		this.trackdraglauncher(coords);
		if(!this.icerink.editmode) {
			this.guideoff();
		}
		if(this.enableon.launcher) {
			this.enableshot();
			this.enableon.launcher=null;
		}
		this.icerink.draglauncher({'x':ev.x,'y':ev.y});
	};
	
	p.droppedlauncher=function(ev) {
		var coords={x:ev.data.global.x,y:ev.data.global.y};
		this.trackadjustedlauncher(coords);
	};

	p.chooseskip=function() {
		this.tries=-1;
		this.trackbeatround();
		this.justwon=true;
		this.choosenext();
	};
	
	p.choosenext=function() {
		this.buttonclick();
		if(currentlevel+1 >= app.config.gameoptions.levelpack) {
		// last level
			this.interlude(true);
		} else if(this.roundnumber < this.roundhistory.length-1) { // admin only, really
			this.roundnumber++;
			var nextround=this.roundhistory[this.roundnumber];
			this.replayround(this.roundnumber);
		} else if((this.roundnumber+1)%roundinterlude===0) {
			this.interlude();	// the zamboni interlude
		} else {
			this.newround();
		}
	};
	
	p.winhistory=function(roundid) {
		// save it to the history
		if(this.iscreating || roundid==this.lastroundid) return; // user did twice in a row...don't save?
		// also don't save winning user-created rounds
		var passdata={};
		// if it's an intro level, save it
		if(this.getroundtype()=="intro") {
			app.usersavestate.introList[roundid]=true;
			passdata.introLevelsCompleted=app.usersavestate.introList;
			if(roundid==app.config.gameoptions.unlockcreateon) {
				app.usersavestate.cancreate=true;
				this.createisunlocked=true;
			}
		} else if(!app.usersavestate.cancreate) { // safety valve in case somehow user didn't get cancreate saved when they played the unlock level; if user is out of intro levels, create should be unlocked.
			app.usersavestate.cancreate=true;
			this.createisunlocked=true;
		}
		this.lastroundid=roundid;
		if(app.usersavestate.levelHistory.length > app.config.gameoptions.historylimit) {
			app.usersavestate.levelHistory.shift();
		}
		app.usersavestate.levelHistory.push(roundid);
		passdata.levelCompleteHistory=app.usersavestate.levelHistory;
		app.alpPlugin.setState(passdata);
		app.saveuserdata();
	};
	
	p.replayround=function(roundnumber) {
		// don't get a new recommended round
		this.roundnumber=roundnumber;
		var lastround=this.roundhistory[roundnumber];
		this.tries=1;
		this.justwon=false;
		this.setlevel(lastround);
		this.trackstartround();
	};
	
	
	p.newround=function() {
		//will be asking for the next kidaptive round
		// TRACK: new round

		this.trackalpsend({req:'getrec'});
		this.roundid=app.alpPlugin.getRecommendation();
		this.trackalpreceive({uri:this.roundid});
		this.tries=1;
		this.justwon=false;
		this.setlevel(this.roundid);
		this.roundhistory.push(this.roundid);
		this.roundnumber=this.roundhistory.length-1;
		currentlevel++;
		if(this.roundnumber+1 >= app.config.gameoptions.unlockcreate) {this.createisunlocked=true;}
		this.trackstartround();
		// also need to start a timer for the round
	};
	

	
	p.interlude=function(lastone) {
		this.showretry("hide");
		this.hidegamestuff();
		this.panel.hideitem('homebutton');		
		this.lastruffmessage=[];
		// show the zamboni and say something
		this.zamboni.visible=true;
		this.panel.setChildIndex(this.zamboni,this.panel.children.length-1);
		var dur=app.config.gameoptions.zambonispeed;
		var xdest;
		if(this.zamboni.flipped) {
			app.soundtrack.playSFX("zamboni_back");
			xdest=0-this.zamboni.scaledhalfwidth;
		} else {		
			app.soundtrack.playSFX("zamboni_forth");
			xdest=app.display.width+this.zamboni.scaledhalfwidth;
		}
		
		if(lastone) {		
			var ruffline=this.rufflines.interlude.picks[parseInt(Math.random() * this.rufflines.interlude.picks.length)];
			this.ruffsayline(this.rufflines.interlude.end.concat(ruffline));
			Tween.get(this.zamboni.position).to({x:xdest},dur);
			this.afterruff=function() {this.backhome();};
		} else {
			Tween.get(this.zamboni.position).to({x:xdest},dur).call(this.endinterlude);
		}
	};
	
	p.endinterlude=function() {
		this.showgamestuff();
		this.zamboni.visible=false;
		this.zamboni.flipped=!this.zamboni.flipped;
		this.zamboni.scale.x=this.zamboni.scale.x*-1;
		this.newround();
	};
	
	p.backhome=function() {
		this.zamboni.visible=false;
		this.zamboni.flipped=!this.zamboni.flipped;
		this.zamboni.scale.x=this.zamboni.scale.x*-1;
		this.icerink.teardown();
		this.showindex(true);
	};
	
	
	p.chooseprev=function() {
		this.panel.ruffsays();
		this.roundnumber--;
		this.replayround(this.roundnumber);
	};
	
	p.chooseretry=function() {	
		this.buttonclick();
		if(this.iscreating) {
			this.setcreate(true);
			this.icerink.noplay(false);
			this.introforcreate();
		} else {
		// don't track round start again. 
		// what if they want to retry after winning?
			if(this.justwon) {
				this.tries=1;
				this.trackstartround();
			}
			this.setlevel(this.roundid,true);
		}
	};
	
	p.showforce=function() {
		var frac=forcelevel/10;
		this.panel.items.forcecover.scale.x=-1*(1-frac);
		this.icerink.setforcelevel(forcelevel);

		var rgb=[255,255,255];
		
		var scale=0.9+(forcelevel/16);
		this.panel.items.outline.scale.x=this.panel.items.outline.scale.y=scale;
		this.panel.items.launchscreen.scale.x=this.panel.items.launchscreen.scale.y=scale;
		this.panel.items.launcherbg.scale.x=this.panel.items.launcherbg.scale.y=scale;
		

		if(forcelevel!==0) {
			for(var g in rgb) {
				rgb[g]=launchcircle.gradient.start[g] + Math.round(launchcircle.gradient.range[g]*frac);
			}
			
			launchcircle.visible=true;
			launchcircle.scale.x=launchcircle.scale.y=(0.4+frac*0.7)*scale;
		} else {
			launchcircle.visible=false;
			rgb=[255,0,0];
		}
		
		

		launchcircle.setcolor(rgb);
		this.icerink.launchcolor=launchcircle.hexcolor;

		this.panel.items.launchammo.position.x=-50+forcelevel*-1;
		
		this.panel.items.launchcannon.position.x=-20+forcelevel*-2;

		
		this.panel.items.thumbtext.text=Math.round(100*forcelevel/10);
		this.panel.items.thumbtext.position.x=thumb.position.x;
		
		
		if(forcelevel===0  || this.cantshootyet) {
			this.disableshot();
		} else if (!this.icerink.checkpredict()) {
			// only make it LOOK disabled, so if user clicks, we can give feedback
			WGBH.UIPanel.setimage(this.panel.items.launchbutton_button,images.pushbutton_down_disabled);
			this.panel.items.launchbutton_text.position.y=this.panel.items.launchbutton_text.initconfig.down;
		} else if (!this.shotready) {
			this.enableshot();
		}
	};
	
	p.addthing=function(ev) {
		
		switch(ev.id) {
			case "addpenguin":
			this.icerink.itemtoadd='penguin';
			break;
			
			case "addbonus":
			this.icerink.itemtoadd='bonus';
			break;
			
			case "addhole":
			this.icerink.itemtoadd='icehole';
			break;
			
			case "addsand":
			this.icerink.itemtoadd='sand';
			break;
			
			case "addmovingpenguin":
			this.icerink.itemtoadd='movingpenguin';
			break;

			case "addtargetplace":
			this.icerink.itemtoadd='targetplace';
			break;
			
			case "addstarguess":
			this.icerink.itemtoadd='starguess';
			break;
			
			
			case "addbush":
			this.icerink.itemtoadd='bush';
			break;
		
		}
		
		var item=this.icerink.putdown(this.icerink.itemtoadd,{x:ev.x,y:ev.y});
		
		item=this.itemfromworldobject(item);
		this.trackdragitem(item,{x:ev.x,y:ev.y,stage_width:app.display.width,stage_height:app.display.height});
		
	};
	
	p.dragitem=function(worldobject,ev) {
	
		var coords={x:ev.data.global.x,y:ev.data.global.y,stage_width:app.display.width,stage_height:app.display.height,};
		var rinkcoords=this.icerink.rinkpos(coords);
		coords.rinkx=rinkcoords.x;
		coords.rinky=rinkcoords.y;
		var item=this.itemfromworldobject(worldobject);
		this.trackdragitem(item,coords);	
	};
	
	p.dropitem=function(worldobject,inrink,remove,coords,isnew) {
		var rinkcoords=this.icerink.rinkpos(coords);
		coords={x:coords.x,y:coords.y,rinkx:rinkcoords.x,rinky:rinkcoords.y};
		var item=this.itemfromworldobject(worldobject);
		if(remove) {
			this.trackremoveitem(item,coords);
		} else if(isnew) {
			this.trackadditem(item,coords);
		} else {
			this.trackmoveitem(item,coords);	
		}
		
		if(remove && isnew) {
			this.currentlevelchanged=false;
		} else {
			this.currentlevelchanged=true;		
		}
	};

	p.itemfromworldobject=function(worldobject) {
		var obj={"id":worldobject.id};
		if(worldobject.id=="movingpenguin" && worldobject.path) {
			obj.path=worldobject.path;
		} else if(worldobject.id=="penguinpathpoint" && worldobject.whatpoint) {
			obj.path=worldobject.whatpoint.obj.special.path;
		}
		return obj;
	};
	
	p.levelintro=function(level) {

		if(this.rufflines.intros[level.id]) {
			return this.rufflines.intros[level.id];
		}
		
		// find a generic one based on this level's tings
		
		// can be about sand, moving penguins, single penguin, multipenguins, icehole, force (no obstacles), clear (no obstacles), star, earlyprediction, laterprediction
		var possibilities=[];
		var empty=true;
		var lineset,linechoice;
		
		if(level.goal.type==="predict") {
			if(level.goal.config==="stars") {
				lineset=this.rufflines.challenges.generics.predictstar;
			} else {
				lineset=this.rufflines.challenges.generics.earlyprediction;
			}
			linechoice=this.rufflines.challenges[lineset[parseInt(Math.random()*lineset.length)]];
			return linechoice;
		}
		
		var totalpenguins=0;
		if(level.penguins) {
			totalpenguins+=level.penguins.length;
			empty=false;
		}
		
		if(level.movingpenguins) {
			totalpenguins+=level.movingpenguins.length;
			possibilities.push("movingpenguins");
			empty=false;
		}
		
		if(totalpenguins===1) {
			possibilities.push("singlepenguin");
			if(!level.lockposition) {	
				possibilities.push("singlepenguinmovable");
			}
		} else if(totalpenguins > 1) {
			possibilities.push("multipenguins");
		}
		
		if(level.holes) {
			possibilities.push("icehole");
			empty=false;
		}
		
		if(level.sand) {
			possibilities.push("sand");
			empty=false;
		}
		
		
		if(!level.lockforce) {
			possibilities.push("force");
		} else if(!level.lockposition) {
			possibilities.push("lockedforce");
		}
		
		if(!level.lockposition) {
			if(empty) {
				possibilities.push("clear");
			}
			possibilities.push("position");
		}
		
		var pickpossible=possibilities[parseInt(Math.random() * possibilities.length)];
		
		lineset=this.rufflines.challenges.generics[pickpossible];
		
		linechoice=this.rufflines.challenges[lineset[parseInt(Math.random()*lineset.length)]];
		
		return linechoice;
	};
	
	p.nextruff=function() {
		if(this.saying.audio) {// ruff is already talking?
			this.tracksaying(this.saying.audio,this.saying.type,"audio",true);
			this.saying.audio=null;
			this.saying.type=null;
		}
		if(!this.ruffstuff || this.ruffstuff.length < 1)  {
			if(this.afterruff) {
				this.afterruff();
				this.afterruff=null;
			}
			return;
		}

		var ruffset=this.ruffstuff.shift();
		
		if(ruffset.audio) {
			this.ruffcorner.saythings(ruffset.audio,this.nextruff);
			this.tracksaying(ruffset.audio,ruffset.type,"audio");
			this.saying.audio=ruffset.audio;
			this.saying.type=ruffset.type;
		}
		if(ruffset.moves) {
			this.ruffcorner.makemoves(ruffset.moves);
		}
		if(ruffset.events) {
			this.ruffcorner.makeevents(ruffset.events);
		}
	};
	
	p.tracksaying=function(audio,type,media,end) {
		switch (type) {
			case "intro":
			this.trackinstruction(audio,media,end);
			break;
			
			case "fail":
			this.trackincorrectfeedback(audio,media,end);
			break;
			
			case "success":
			this.trackcorrectfeedback(audio,media,end);
			break;
		}
	};
	
	p.showcaption=function(ev) {
		this.panel.ruffsays(app.captions._data[ev.text]);
	};
	
	
	
	p.setcreate=function(retry,clear) {
		var workinglevel;
		if(clear || !this.usercreatedlevels[this.createdpick]) {
	
			if(this.createdpick<0 && (getqs('lv') || getqs('kid'))) {
			 // pull it from the URL
				if(getqs('lv')) {
			 		workinglevel=this.parselevelurl();
			 	} else if(getqs('kid')) {
			 		workinglevel=this.lookupkidlevel(getqs('kid'));
			 	}
			} else {// use the blank level
				workinglevel=app.config.levels.levels.create;
				if(!clear) {
					this.currentlevelchanged=false;
				}
			}
		} else { // load the user's level
			workinglevel=this.usercreatedlevels[this.createdpick];
		}
		
		this.panel.showitem('homebutton');

		this.currentround=this.icerink.setlevel(workinglevel,retry);

		this.roundid=app.roundid="USER_" + this.currentround.id;
		
		this.setcreatetype(this.currentcreatetype());	
		this.levelready();
	};
	
	p.toggleforcelock=function() {
		var isforcelock=(this.icerink.getlockedforce())?true:false;
		this.panel.items.lockforce.text=(isforcelock)?"F:Y":"F:N";
		this.icerink.setsliderlock(!isforcelock);
	};
	
	p.togglepositionlock=function() {
		var isposlock=(this.icerink.getlockedposition())?true:false;
		this.panel.items.lockposition.text=(isposlock)?"P:Y":"P:N";
		this.icerink.setlauncherlock(!isposlock);
	};
	
	p.togglelevelconfig=function() {
		var c=document.getElementById('output');
		if(c.style.display=='none') {
			var currentconfig=this.icerink.showlayout();
			this.showconfig(currentconfig);
		} else {
			this.hideconfig();
		}
	};
	
	p.chosetarget=function(chosencoords,mousecoords) {
		// record whether user chose correct target for this prediction round

		var correcttarget=this.currentround.solution;
		
		var iscorrect=false;
		if(correcttarget){
			iscorrect=(chosencoords[0]==correcttarget[0] && chosencoords[1]==correcttarget[1]);
		}
		this.trackuserprediction(mousecoords,chosencoords,correcttarget,iscorrect);
	};
	
	/* ADMIN STUFF */
	p.showconfig=function(currentconfig) {
		var c=document.getElementById('output');
		c.innerHTML="<div>"+JSON.stringify(currentconfig)+"</div>";
		var url=this.showlevelurl(currentconfig);
		var urlvis="LINK";
		c.innerHTML+="<br/><br /><a href=\"" + url +"\" target=\"new\" >"+urlvis+"</a>";
		
		c.style.display='block';
	};
	p.hideconfig=function() {
		var c=document.getElementById('output');
		c.style.display='none';
	};
	
	p.switchcreatetype=function() {
		var nexttypes={
			"normal":"predict",
			"predict":"stars",
			"stars":"normal"
		};
		
		this.setcreatetype(nexttypes[this.currentcreatetype()]);		
	};
	
	p.currentcreatetype=function() {
		var goal=this.icerink.getgamesettings().goal;
		var createtype=goal.type;
		if(goal.config=='stars') {
			createtype='stars';
		}
		return createtype;
	};
	
	p.setcreatetype=function(type) {
		this.icerink.setgametype(type);
		this.createtype=type;
		switch(type) {
			case "normal":
			this.icerink.target.show();
			this.panel.hideitem('addtargetplace');
			this.panel.hideitem('addstarguess');
			this.panel.showitem('addbonus');
			// show the target on the ice. Hide stars and target destinations in the tray and remove stars and target destinations from the ice (or just hide them?)
			this.icerink.removeallid('targetplace');
			this.icerink.removeallid('starguess');
			break;
			
			case "predict":
			this.icerink.target.hide();
			this.panel.showitem('addtargetplace');
			this.panel.hideitem('addstarguess');
			this.panel.hideitem('addbonus');
			this.icerink.removeallid('starguess');
			// hide the target and show the target destinations in the tray. Hide star destinations from tray, remove stars from the ice.
			break;
			
			case "stars":
			this.icerink.target.hide();
			this.panel.hideitem('addtargetplace');
			this.panel.showitem('addstarguess');
			this.panel.hideitem('addbonus');
			this.icerink.removeallid('targetplace');
			// hide the target and show the outlined stars in the tray. Remove target destinations from the ice.
			break;
		
		}
	};
	
	p.lookupkidlevel=function(kidaptiveuri) {
		var config=app.config.levels.levels[kidaptiveuri];
		if(!config) {
			config=app.config.levels.levels.notfound;
		}
		config.kid=kidaptiveuri;
		return config;
	};
	
	p.showlevelurl=function(levelconfig) {
		var url=window.location.origin+window.location.pathname+"?lv=" +encodeURI(JSON.stringify(levelconfig));
		return url;
	};
	
	p.parselevelurl=function(fromurl) {
		if(!fromurl) fromurl=getqs('lv');
		fromurl=decodeURI(fromurl);
		var config=JSON.parse(fromurl);
		return config;
	};
	
	p.saveuserlevel=function(levelconfig) {
		this.usercreatedlevels[this.createdpick]=levelconfig;
		this.showuserlevel(levelconfig);
		app.usersavestate.createdLevels[parseInt(this.createdpick)]=levelconfig;
		app.saveuserdata();
		this.showlevelurl(levelconfig);
	};
	
	p.showuserlevel=function(levelconfig) {
		document.getElementById('output').innerHTML=JSON.stringify(levelconfig);
	};
	
	p.getuserlevels=function() {
		this.usercreatedlevels=[];
		var numlevels=app.usersavestate.createdLevels.length;
		if(!numlevels) {
			return;
		}
		
		for(var i=0;i<numlevels;i++) {
			var userlevel=app.usersavestate.createdLevels[i];
			this.usercreatedlevels[i]=userlevel;
		}
	};
	
	p.urllevel=function() {
		this.setlevel('url');
		if(getqs('kid')) {
			this.tries=1;
			this.trackstartround();
		}
	};
	
	p.setlevel=function(levelid,retry) {
		var level;
		if(levelid==='url') {
			if(getqs('kid')) {
				this.roundid=getqs('kid');
				level=this.lookupkidlevel(this.roundid);
			} else {
				level=this.parselevelurl();
				this.roundid="fromURL";
			}
		} else {
			this.roundid=levelid;
			level=this.lookupkidlevel(this.roundid);
		}


		this.panel.showitem('homebutton');
		
		app.roundid=this.roundid;
		level=this.icerink.setlevel(level,retry);

		this.panel.items.levelinfo.text=this.roundid;
		
		this.currentround=level;
		level.id=this.roundid;
		
				

		this.levelready();
		this.panel.showitem("editpanel",false);
		this.showforce();
		this.icerink.noplay(false);
		
		this.lastruffmessage=[];
		
		var ruffline,holdonly=false;
		if(!retry || this.currentround.goal.type==="predict") {
			this.hideguidebutton();
		} else {
			if(!this.userstatus.heardhint) {
				this.userstatus.heardhint=true;
				ruffline=this.rufflines.help.notehint;
			}
			this.showguidebutton();
		}
		
		if(!ruffline && this.levelintro(level)) { // only intro the first time? For intro levels or all levels?
			
			//if(this.getroundtype()!=='intro' || !this.userstatus.heardintro[level.id]) {
				ruffline=this.levelintro(level);
				this.userstatus.heardintro[level.id]=true;
				if(retry) {
					holdonly=true;
				}
//			}
			
		}
		
		if(ruffline) {
			this.ruffsayline(ruffline,'intro',holdonly);
		}
		
		
		if(this.currentround.solution) {
			this.panel.items.buttonshowme.visible=true;
			if(!retry) {
			if(!this.currentround.lockforce) {
			// set the force into place
				this.movethumbto(1);
			}
			if(!this.currentround.lockposition) {
				this.icerink.placelauncher(0,220);
			}
			}
		} else {
			this.panel.items.buttonshowme.visible=false;
		}
		
		this.enableshot();
			
		if(this.currentround.mustforce) {
			this.disableshot();
			this.enableon.thumb=true;
			this.cantshootyet=true;
		}
		
		if(this.currentround.mustlaunch) {
			this.disableshot();
			this.enableon.launcher=true;
			this.cantshootyet=true;
		}
		
		this.stars=this.icerink.getstars();
		this.targets=this.icerink.gettargets();
		
		
	};
	
	p.levelready=function() {
		var islocked=this.icerink.getlockedforce();
		
		var img=islocked?"force_slider_disabled":"force_slider";
		var gradientimg=islocked?"force_gradient_disabled":"force_gradient";
		this.panel.showitem("sliderslot",!islocked);
		
		WGBH.UIPanel.setimage(this.panel.items.forcegradient,images[gradientimg]);
		WGBH.UIPanel.setimage(thumb,images[img]);
		WGBH.UIPanel.setimage(this.panel.items.buttonguide,images.path_button_off);
		
		this.showretry("hide");
		
		this.setmode('play');
	};
	
	p.setforcreate=function() {
		this.setmode('play');		
		this.panel.hideitem("switchtoedit");
	};
	
	
	
	p.ready=function() {
		this.setupgame();

// show index page when ready

		this.panel.indexpane(this.createisunlocked);
		this.hideconfig();
		this.panel.hideitem("createindex");
		this.hidegamestuff();
		this.panel.hideitem('homebutton');
		this.background=this.panel.background1;
	};
	
	
	p.stopped=function(ev) {
		// This gets called when everything has stopped moving. Used to show replay; may still need to do something.
	};
	
	
	p.showretry=function(status) {

		if(status=='hide') {
			// TODO - get this slide-in working with SpringRoll Scaling; in the meantime, just hide/show it.
			Tween.get(this.panel.items.retrypanel.position).to({x:this.panel.items.retrypanel.xout},200,Ease.quadOut);
			this.panel.hideitem("scrim");
			return;
		}
		
		this.panel.hideitem('homebutton');
			// get star results from icerink.starresult object
			// get shot results from icerink.shotstatus object
		this.panel.showitem("scrim");
		if(this.iscreating) {
		// don't show retry in edit mode?
			if(adminmode) {
				if(status=='win') {
					// get the solution! In admin mode
					var solution;
					switch (this.createtype) {
						case 'predict':
						solution=this.icerink.shotstatus.targetpicked;
						break;
						
						case 'stars':
						solution=this.icerink.shotstatus.stars.correct;
						break;
						
						case 'normal':
						
						solution=[this.icerink.shotstatus.launcherpos[0],this.icerink.shotstatus.launcherpos[1],this.icerink.shotstatus.force];
						break;
					}
					
					var currentconfig=this.icerink.showlayout();
					currentconfig.solution=solution;
					this.showconfig(currentconfig);
				}
			}
			
			this.panel.hideitem('nextlevelbutton');
			this.panel.hideitem('nextdisabled');
			this.panel.showitem('editbutton');
			
		} else if(status=='win') {
				
			this.panel.showitem('nextlevelbutton');
			this.panel.hideitem('nextdisabled');
			this.panel.hideitem('editbutton');
			// TRACK: "beat round"
			this.trackendshot(true);
			this.trackbeatround();
			this.justwon=true;
			
			// PUSH it onto history...
			this.winhistory(this.roundid);
		
		} else {
			
			this.tries++;
			this.panel.hideitem('nextlevelbutton');
			this.panel.showitem('nextdisabled');
			this.panel.hideitem('editbutton');
			this.trackendshot(false);
		}
		
		
		Tween.get(this.panel.items.retrypanel.position).to({x:this.panel.items.retrypanel.xin},350,Ease.getBackOut(2));
		this.panel.showitem('retrypanel');
		
		// disable all other controls
		this.setmode("retry");

	};
	
	p.setmode=function(playmode) {
		switch(playmode) {

			case 'play':
				this.playmode='play';
//				this.panel.items.playitems.visible=true;
				this.panel.showitem('playitems');
				this.icerink.setplaymode(this.playmode);
			break;
			
			case 'retry':
				this.playmode='retry';
				// disable controls
				
			break;
			
			case 'shot':
				this.playmode="shot";
			break;
		}
	};
	
	p.shot=function(ev) {
		this.icerink.guideon=false;
	};
	
	p.shootit=function() {
		if(!this.shotready) return;
		if(this.icerink.shootit(forcelevel)) {
			this.dismissruff();
			this.ruffsayline(this.rufflines.intros.whileshooting,'intro',true);
			synth.stop();
			app.soundtrack.playSFX('zip');
			// turn off the guide
			this.guideoff();
			// in fact, hide guide entirely
			this.hideguidebutton();
			this.panel.items.launchammo.visible=false;
			Tween.get(this.panel.items.launchcircle.scale).to({x:0,y:0},200);
			
			Tween.get(this.panel.items.launchcannon.position).to({x:-20},50);
			

			this.trackshootit(this.icerink.configfromstate(this.icerink.history[0].initial));
			this.setmode('shot');
		}
	};
	
	
	p.reload=function() {
		this.panel.items.launchammo.visible=true;
		this.showforce();
	};
	
	p.outofshots=function() {
		this.disableshot();
	};
	
	p.disableshot=function() {
		if(!this.shotready) return;
		this.shotready=false;
		WGBH.UIPanel.setimage(this.panel.items.launchbutton_button,images.pushbutton_down_disabled);
		this.panel.items.launchbutton_text.position.y=this.panel.items.launchbutton_text.initconfig.down;
	};
	
	p.enableshot=function() {
		this.shotready=true;

		this.cantshootyet=false;
		WGBH.UIPanel.setimage(this.panel.items.launchbutton_button,images.pushbutton);
		this.panel.items.launchbutton_text.position.y=this.panel.items.launchbutton_text.initconfig.frame.y;
	};
	
	p.dragthumb=function(ev) {
		if(this.playmode!='play' || this.icerink.notplaying) return;
		if(this.icerink.getlockedforce()) {
			this.forcealert();
			return;
		}
		this.dismissruff();
		this.guideoff();

		var coords={'x':ev.x,'y':ev.y};
		this.trackdragslider(coords);

		if(this.enableon.thumb) {
			this.enableshot();
			this.enableon.thumb=null;
		}
		var b=ev.target.getBounds();
		var dro=(b.x + b.width/2)-ev.x;

		thumb.offset=dro/ev.target.worldTransform.a;

		this.panel.on(app.dragtype,this.movethumb);
		this.panel.on(app.releasetype,this.dropthumb);
		//synth.start();
		
		synth.setvolume(4);
	};
	
	p.alertable=function() {
		if(this.ruffstuff && this.ruffstuff.length > 0) return false;
		return true;
	};
	
	p.predictalert=function() {
		// remind user they have to make a prediction before tryig to shoot it
		// don't alert while intro is going
		if(!this.alertable()) return;
		if(this.getroundtype()==="star predict") {
			this.ruffsayline(this.rufflines.alert.predictionalertstars,"alert");
		} else {
			this.ruffsayline(this.rufflines.alert.predictionalert,"alert");
		}
	};
	
	p.forcealert=function() {
		if(!this.alertable()) return;
		if(this.icerink.getlockedposition()) {
			this.lockallalert();
			return;
		}
		var pick=this.rufflines.alert.force[parseInt(Math.random() * this.rufflines.alert.force.length)];
		this.ruffsayline(this.rufflines.alert[pick],"alert");
	};
	
	p.positionalert=function() {
		if(!this.alertable()) return;
		if(this.icerink.getlockedforce()) {
			this.lockallalert();
			return;
		}
		var pick=this.rufflines.alert.position[parseInt(Math.random() * this.rufflines.alert.position.length)];
		this.ruffsayline(this.rufflines.alert[pick],"alert");
	};
	
	p.lockallalert=function() {
		if(!this.alertable()) return;
		var line=this.rufflines.alert.lockallalert.slice();
		var t=this.icerink.getgamesettings().goal;
		if(t.type==="predict") {
			if(t.config==="stars") {
				line=line.concat(this.rufflines.alert.predictionalertstars);
			} else{
				line=line.concat(this.rufflines.alert.predictionalert);
			}
		}
		this.ruffsayline(line,"alert");
	};
	
	p.movethumb=function(ev) {
	
		var xpos=(ev.data.global.x - this.panel.items.controls.x)/this.icerink.container.scale.x;

		xpos+=thumb.offset;

		if(xpos > thumb.max) {
			xpos=thumb.max;
		} else if(xpos < thumb.min) {
			xpos=thumb.min;
		}
		thumb.position.x=Math.round(xpos);

/*		forcelevel=10*(xpos-thumb.min)/(thumb.max-thumb.min);
		this.showforce();
*/
		this.readthumb();
		synth.setpitch(100+30*forcelevel,90+20*forcelevel);
	};
	
	p.readthumb=function() {
		forcelevel=10*(thumb.position.x-thumb.min)/(thumb.max-thumb.min);
// lop off some of the "precision"
		forcelevel=Math.round(forcelevel*10)/10;
		this.showforce();
	};
	
	p.movethumbto=function(forcelevelin) {
		forcelevel=forcelevelin;
		thumb.position.x=Math.round(thumb.min+thumb.range*(forcelevel/10));
		this.showforce();
	};
	
	p.dropthumb=function(ev) {
		this.panel.off(app.dragtype,this.movethumb);
		this.panel.off(app.releasetype,this.dropthumb);
		this.movethumbto(forcelevel);
		var coords={x:ev.data.global.x,y:ev.data.global.y};
		this.trackadjustedlauncher(coords);
		//synth.setvolume(1);
		synth.stop();
	};

	p.toplaymode=function(ev) {
		this.buttonclick();
		this.dismissruff();
		this.icerink.stopedit();
		this.icerink.savecreatedlevel();
		this.icerink.refresh();
		this.setmode('play');		
		this.icerink.noplay(false);
		
		this.hideconfig();
			
		this.setcreate(true);
		// save level and then load saved level
		
		app.setTimeout(this.updateeditui,10);
		this.introforcreate();

	};
	
	p.introforcreate=function() {
		if(!this.userstatus.heardintro.createplaylong) {
			this.ruffsayline(this.rufflines.intros.createplaylong);
			this.userstatus.heardintro.createplaylong=true;
		} else {	
			this.ruffsayline(this.rufflines.intros.createplay);
		}
	};
	
	p.backtoeditmode=function(ev) {
		this.dismissruff();
		this.ruffsayline(this.rufflines.intros.createagain,'intro',true);
		this.buttonclick();
		this.setcreate(true);
		this.icerink.startedit();
		app.setTimeout(this.updateeditui,10);
	};
	

	p.updateeditui=function() {
		this.panel.editmode(this.icerink.editmode);
		this.panel.showitem("editpanel",this.icerink.editmode);
		this.panel.showitem("controls",!this.icerink.editmode);
		this.panel.showitem("switchtoedit",!this.icerink.editmode);
	};
	
	p.clickedruff=function(ev) {
		if(this.lastruffmessage && this.lastruffmessage.length > 0 && this.ruffcorner.incorner && !this.ruffcorner.talking) {
			this.ruffsayline(this.lastruffmessage);
			this.trackhint('ruff',{x:ev.data.global.x,y:ev.data.global.y});
		} else {
			this.dismissruff();
			if(this.afterruff) { // call an event when all is done
				this.afterruff();
				this.afterruff=null;
			}
		}
	};
	
	p.hideguidebutton=function() {
    	this.panel.hideitem('buttonguide');
    };
    
    p.showguidebutton=function() {
    	this.panel.showitem('buttonguide');
    };
    
    p.guideoff=function() {
	   	WGBH.UIPanel.setimage(this.panel.items.buttonguide,images.path_button_off);
		this.icerink.guideon=false;
		this.icerink.reverseon=false;
		this.icerink.clearguide();
    };
    
    p.guideon=function() {
    
		
			this.icerink.guideon=true;		
			this.icerink.reverseon=false;
			this.icerink.showguide();
			WGBH.UIPanel.setimage(this.panel.items.buttonguide,images.path_button_on);
    };
	
	p.toggleguide=function(ev) {
		if(this.playmode!='play') return;
		if(!this.panel.items.buttonguide) {this.icerink.guideon=false; return;}
		this.buttonclick();
		if(this.icerink.guideon) {
			this.guideoff();
		} else {
			this.trackhint('guide',{x:ev.x,y:ev.y});
			this.guideon();
		}
	};
	
	
	p.showanswer=function() { // ADMIN/testing only, really. Probably won't keep
		if(this.currentround.solution) {
		
			switch(this.getroundtype()) {
				case "challenge":
					// put the launcher into place
					this.icerink.placelauncher(this.currentround.solution[0],this.currentround.solution[1]);
					// set the force into place
					this.movethumbto(this.currentround.solution[2]);
				break;
			
				case "star predict":
				// or if it's about the stars, show the stars:
					// TODO unselect all the non-star answers!
					var st;
					this.icerink.clearstars();
					for(st in this.currentround.solution) {
						var star=this.icerink.getObjectAtPos(this.currentround.solution[st]);
						if(star) {
							this.icerink.selectstar(star,true);
						}
					}
				break;
				
				case "target predict":
				// or if it's about the target, show which target:
					var targ=this.icerink.getObjectAtPos(this.currentround.solution);
					if(targ) {
						this.icerink.selecttarget(targ);
					}
				break;
			}
		}
	};
	
	p.hsl2rgb=function(h,s,l) {
	/*
	H (hue) = 0, if R = G = B, otherwise a value between 0 and 255, with the range of 0 to 255 being split into three strips for G to B, B to R and R to G gradients.
	L (lightness) = (M + m) / 2, where M is max(R, G, B) and m is min(R, G, B).
	S (saturation) = 0, if R = G = B, otherwise 255 * (M - m) / (M + m), if L < 128, otherwise 255 * (M - m) / (511 - (M + m)).
	*/
	
	// PS Hue 360 degrees: 0=red, 120=green, 240=blue. 00ff33=132; 00cc33=135 (0,204,51); 00ff40=135 (0,255,64). (4:1)  2:1=150; 1:1=180
		
	
	};
	
	p.rgb2hsl=function(r,g,b) {
		var h,s,l,mmax,mmin,mmid;
		mmax=Math.max(r,g,b);
		mmin=Math.min(r,g,b); // the min can be discounted for hue 
		

		var peaks={'r':0,'g':120,'b':240};
	// top two colors determine the hue. Red->green is 0->120, green->blue is 120->240, blue->red is 240->360
		
		var rgb=[r,g,b];
		var rgbq=['r','g','b'];
		var max,mid,min;
		for(var c in rgb) {
			if(rgb[c]==mmax) {
				max=rgbq[c];
			} else if(rgb[c]==mmin) {
				min=rgbq[c];
			} else {
				mid=rgbq[c];
				mmid=rgb[c];
			}
		}
		
		l=(mmax + mmin)/2;
		if(r==g && g==b) {
			h=0;
			s=0;
		} else {
			h=(r*peaks[r] + g*peaks[g] + b*peaks[b])/(r+g+b);
			if(l<128) {
				s=255 * (mmax - mmin) / (mmax + mmin);
			} else {
				s=255 * (mmax - mmin) / (511 - (mmax + mmin));
			}
		}
		return {"h":h,"s":s,"l":l};
	};	
	
	
	p.clickbg=function(ev) {
	// user's click got through to background
		app.trackstrayclick(ev);
	};
	
	p.clickice=function(ev) {
// User clicked on blank ice
		app.trackstrayclick({x:ev.x,y:ev.y});
	};
	


	p.pointruff=function(target,direction) {
		if(direction===undefined) direction='auto';
		this.ruffcorner.pointat(target,500,direction);
	};
	
	p.dismissruff=function() {
	
		if(this.saying.audio) {
			this.tracksaying(this.saying.audio,this.saying.type,"audio",true);
			this.saying.audio=null;
			this.saying.type=null;
		}
	
		this.ruffcorner.switchmouth('happy');
		this.ruffstuff=null;
		// in case it's moving the thumb:
		app.off('update',this.readthumb);
		app.off('update',this.matchlauncher);
		
		Tween.removeTweens(this.thumb.position);
		Tween.removeTweens(this.panel.items.thumbtext.position);
		if(this.showthumb) {
			this.readthumb();
			this.showthumb=null;
		}
		
		// in case it's moving the launcher:
		if(this.showlauncherpos) {
			Tween.removeTweens(this.showlauncherpos.y);
			this.showlauncherpos=null;
		}
		
		this.ruffcorner.skipall();
	};

	/**
	 * When the state fully exits
	 * @method  exit
	 */
	p.exit = function()
	{
		
		this.ruffcorner.events.off("movelauncher",this.movelauncher);
		this.ruffcorner.events.off("moveslider",this.moveslider);
		this.ruffcorner.events.off("showstar",this.showstar);
		this.ruffcorner.events.off("showtarget",this.showtarget);
		
		this.ruffcorner.events.off("pointedat",this.adjusttouched);
		
		app.off('update',this.readthumb);
		app.off('update',this.matchlauncher);
		this.icerink.teardown();
		this.stopscale();
	};


	p.getrinkstate=function(aftershot) {
		var layout=this.icerink.showlayout(); // but replace the ID and remove the hint
		delete layout.hint; // unnecessary
		layout.id=this.roundid;
		layout.solution=this.currentround.solution;

		if(aftershot) { // additional info when this is at the end of a shot
			layout.plushiepath={};
			for(var stat in this.icerink.shotstatus.plushie) {
				layout.plushiepath[stat]=this.icerink.shotstatus.plushie[stat];
			}
			layout.stars=this.icerink.shotstatus.stars;
		}
		return layout;
	};
	
	p.getplushiehits=function() {
		var pset=[];
		for(var id in this.icerink.shotstatus.plushie.obstacles) {
			var wo=this.icerink.shotstatus.plushie.obstacles[id];
			pset.push({"id":wo.id,"pos":wo.pos,"plushie":wo.pos2});
		}
		return pset;
	};
	
	p.getroundtype=function(checkid) {
		if(!checkid) {checkid=this.roundid;}
		if(checkid.indexOf('intro_')===0) return "intro";
		if(checkid.indexOf('chal_')===0) return "challenge";
		
		if(checkid.indexOf('pred_')===0) {
			if(checkid.indexOf('_tgt') > -1) {
				return "target predict";
			} else {
				return "star predict";
			}
		}
		return "unknown";
	};


	/** 
	tracking functions 
	
	2000 (startGame) is automatic
	
	*/
	
	
	// 4011
	p.trackstartplaymode=function() {
		app.learning.startTimer('play');
		app.trackevent('startPlayMode',{
			"idorder":["kid","coords"],
			"kid":this.roundid,
			"coords":{x:0,y:0}
		});
	};
	
	// 2020
	p.trackstartround=function(){
		app.learning.startTimer('round');
		app.trackevent('startRound',{
			"idorder":["round_type","initial_state","round_target","kid","resourcelist","wasrecommended"],
			"kid":this.roundid,
			"round_type":this.getroundtype(),
			"round_target":0, // should remove
			"initial_state":this.getrinkstate(),
			"wasrecommended":true, // should remove
			"resourcelist":[] // should remove
		}); // send kid_uri, round_type, initial_state (the base state for the round)
		
	};
	
	// 2030
	p.trackbeatround=function() {
		app.trackevent('endRound',{
				"idorder":["duration","round_type","misses","kid"],
				"kid":this.roundid,
				"round_type":this.getroundtype(),
				"duration":app.learning.stopTimer('round'),
				"misses":this.tries-1
		}); // send duration, 
	};
	
	
	// 4100
	p.trackshootit=function(state) {
		app.learning.startTimer('shot');
			app.trackevent('submitAnswer',{
				"idorder":["coordinates","projectile","rink_state","correct","kid"],
				"kid":this.roundid,
				"projectile":"fish", // it's ALWAYS a fish though!
				"coordinates":{}, // is this relevant?
				"rink_state":state,
				"correct":false
		});
	};
	
	
	// 5000 
	p.trackendshot=function(correct) {
			app.trackevent('endShot',{
			"idorder":["correct","final_state","kid","duration","collisions"],
			"kid":this.roundid,
			"final_state":this.getrinkstate(true),
			"correct":correct,
			"duration":app.learning.stopTimer('shot'),
			"collisions":this.getplushiehits()
			});
	};
	
	// 4020 selectAnswer
	p.trackuserprediction=function(coordinates,predicted,correct,iscorrect) {
			// predicted and correct come in as arrays
			predicted=JSON.stringify(predicted);
			correct=JSON.stringify(correct);

			app.trackevent('selectAnswer',{
			"idorder":["coordinates","correct","prediction","correct_prediction","kid"],
			"coordinates":coordinates,
			"kid":this.roundid,
			"correct_prediction":correct,
			"prediction":predicted,
			"correct":iscorrect
			});
	};
	
	// 6000
	p.trackalpsend=function(data) {
		app.trackevent('sentALP',{
			"idorder":["data","kid"],
			"kid":this.roundid,
			"data":data
			});
	};
	
	// 6010
	p.trackalpreceive=function(data) {
		app.trackevent('receivedALP',{
			"idorder":["data","kid"],
			"kid":this.roundid,
			"data":data
			});
	};


	// 4012
	p.trackstartcreatemode=function() {
		app.learning.startTimer('create');
		app.trackevent('startCreateMode',{
			"idorder":["kid","coords"],
			"kid":this.roundid,
			"coords":{x:0,y:0}
		});
	};
	
	// 2025
	p.trackstartcreate=function(isnew) {
		app.learning.startTimer('creating');
		app.trackevent('startCreation',{
			"idorder":["kid","new_creation"],
			"kid":this.roundid,
			"new_creation":isnew
		});
	};
	
	// 2035
	p.trackendcreate=function() {
		app.trackevent('endCreation',{
			"idorder":["duration","created_level","kid"],
			"kid":this.roundid,
			"duration":app.learning.stopTimer('creating'),
			"created_level":this.getrinkstate()
		});
	};
	
	// 2039
	p.trackclickhome=function(mode) {
		var dur=0;
		app.learning.stopTimer('round');
		if(mode) {
			dur=app.learning.stopTimer(mode);
		}
		app.trackevent('clickHome',{
			"idorder":["kid","duration","mode"],
			"kid":this.roundid,
			"duration":dur,
			"mode":mode
		});
	};
	
	// no separate event for this; do we want?
	p.trackdragslider=function(coords) {
		app.learning.startTimer('dragging');
	};
	
	// 4030
	p.trackdraglauncher=function(coords) {
		app.learning.startTimer('dragging');
		app.trackevent('startDrag',{
			"idorder":["coordinates","drag_type","kid"],
			"kid":this.roundid,
			"coordinates":coords,
			"drag_type":"drag"
		});
	};
	
	// 4021
	p.trackadjustedlauncher=function(coords) {
		var launchinfo=this.icerink.getlauncherspec();
		app.trackevent('adjustLauncher',{
			"idorder":["coordinates","correct","launcher_position","launcher_force","kid","duration"],
			"kid":this.roundid,
			"duration":app.learning.stopTimer('dragging'),
			"coordinates":coords,
			"correct":false,
			"launcher_position":this.icerink.rinkpos(launchinfo.position),
			"launcher_force":Math.round(10*launchinfo.force)
		});
	};
	
	//4031
	p.trackdragitem=function(object,coords) {
		app.learning.startTimer('dragging');
		app.trackevent('dragItem',{
			"idorder":["coordinates","object","drag_type","kid"],
			"coordinates":coords,
			"object":object,
			"drag_type":"drag",
			"kid":this.roundid
		});
	};
	
	// 4023
	p.trackadditem=function(object,coords) {
		app.trackevent('addItem',{
			"idorder":["coordinates","object","kid","duration","rink_state"],
			"coordinates":coords,
			"object":object,
			"rink_state":this.getrinkstate(),
			"kid":this.roundid,
			"duration":app.learning.stopTimer('dragging')
		});
	};
	
	// 4024
	p.trackmoveitem=function(object,coords) {
		app.trackevent('moveItem',{
			"idorder":["coordinates","object","rink_state","kid","duration"],
			"coordinates":coords,
			"object":object,
			"rink_state":this.getrinkstate(),
			"kid":this.roundid,
			"duration":app.learning.stopTimer('dragging')
		});
	};
	
	// 4025
	p.trackremoveitem=function(object,coords) {
		app.trackevent('removeItem',{
			"idorder":["coordinates","object","rink_state","kid","duration"],
			"coordinates":coords,// looking incorrectly for an INT...
			"object":object, //looking incorrectly for an INT...
			"rink_state":this.getrinkstate(), //but it's looking for an INT
			"kid":this.roundid,
			"duration":app.learning.stopTimer('dragging')
		});
	};
	
	// 4090
	p.trackhint=function(type,coords) {
		app.trackevent('clickHelp',{
			"idorder":["coordinates","kid","help_type"],
			"kid":this.roundid,
			"coordinates":coords,
			"help_type":type
		});
	};
	
// feedback events have many similarities
	p.getfeedbackinfo=function(name) {
		// lookup info about this feedback?
		var caption=app.captions.data[name];
		var totaldur=app.captions.getLength(name);
		var totaldesc=app.captions.getFullCaption(name);
		return {duration:totaldur,description:totaldesc};
	};

	p.getfeedbacktrackobject=function(name,type) {
		var feedbackobj=this.getfeedbackinfo(name);
		return {
			"media_type":type,
			"duration":feedbackobj.duration,
			"description":feedbackobj.description,
			"id":name,
			"kid":this.roundid,
			"add":{"kidaptive_uri":this.roundid},
			"idorder":["description","id","media_type","duration","add"]
		};
	};
	
	// 3021 and 3121
	p.trackcorrectfeedback=function(name,type,isend) {
		var trackobj=this.getfeedbacktrackobject(name,type);
		if(isend) {
			trackobj.duration=app.learning.stopTimer('talking');
			app.trackevent('endCorrectFeedback',trackobj);
		} else {
			app.learning.startTimer('talking');
			app.trackevent('startCorrectFeedback',trackobj);
		}
	};
	
	// 3120 and 3121
	p.trackincorrectfeedback=function(name,type,isend) {
		var trackobj=this.getfeedbacktrackobject(name,type);
		if(isend) {
			trackobj.duration=app.learning.stopTimer('talking');
			app.trackevent('endIncorrectFeedback',trackobj);
		} else {
			app.learning.startTimer('talking');
			app.trackevent('startIncorrectFeedback',trackobj);
		}
	};
	
	// 3010 and 3110
	p.trackinstruction=function(name,type,isend) {
		var trackobj=this.getfeedbacktrackobject(name,type);
		if(isend) {
			trackobj.duration=app.learning.stopTimer('talking');
			app.trackevent('endInstruction',trackobj);
		} else {
			app.learning.startTimer('talking');
			app.trackevent('startInstruction',trackobj);
		}
	};

	//Assign to namespace
	namespace("WGBH").GameState = GameState;
}());
